import Lottie from 'lottie-react';

import faceTalkingBored from '../jsons/Face_Talking_Bored.json';

const FaceTalkingBored = props => {
  return <Lottie animationData={faceTalkingBored} {...props} />;
};

export default FaceTalkingBored;
